// @flow
import FormattedCurrencyContainer from '../../components/Formatted/FormattedCurrencyContainer';
import { FormattedMessage } from 'react-intl';
import ItemPriceGatewayContainer from '../../components/ItemPriceGateway/ItemPriceGatewayContainer';
import React from 'react';
import styles from './PriceRow.module.scss';

type Props = {
    bidActivityCount: number,
    bidCount: number,
    buyNowPrice: number,
    buyNowStatus: string,
    catalogStatus: string,
    currency: string,
    isAvailable: boolean,
    isCatalogOnly: boolean,
    isLotOpen: boolean,
    isPassed: boolean,
    isSold: boolean,
    isUnsold: boolean,
    leadingBid: number,
    salePrice: number,
    startPrice: number,
};

const PriceRow = (props: Props) => {
    const {
        bidActivityCount,
        bidCount,
        buyNowPrice,
        buyNowStatus,
        catalogStatus,
        currency,
        isAvailable,
        isCatalogOnly,
        isLotOpen,
        isPassed,
        isSold,
        isUnsold,
        leadingBid,
        salePrice,
        startPrice,
    } = props;

    const currentPrice = leadingBid || salePrice || startPrice || 0;
    const numberOfBids = 0 + Number(bidCount) + Number(bidActivityCount);
    const buyNowAvailable = buyNowStatus === 'available' && catalogStatus === 'done';

    return (
        <div className={styles['item-bids-container']}>
            {isLotOpen ? (
                <div className={styles['live-item-current-bid-container']}>
                    <div className={styles['item-live-bid']}>
                        <div className={styles['bid-amount']}>
                            <FormattedCurrencyContainer value={currentPrice} sourceCurrency={currency} noFraction />
                        </div>
                        <div className={styles['bid-count']}>
                            {numberOfBids === 0 ? null : numberOfBids === 1 ? (
                                <FormattedMessage id="oneBid" />
                            ) : (
                                <FormattedMessage id="bids_with_count" values={{ numberOfBids }} />
                            )}
                        </div>
                    </div>
                </div>
            ) : buyNowAvailable ? (
                <span className={styles['item-current-bid-container']}>
                    <span className={styles['item-current-bid']}>
                        <FormattedMessage
                            id="buy_now_for"
                            values={{
                                price: <FormattedCurrencyContainer value={buyNowPrice} sourceCurrency={currency} />,
                            }}
                        />
                    </span>
                </span>
            ) : isAvailable && !isUnsold && !isCatalogOnly ? (
                <span className={styles['absentee-item-current-bid-container']}>
                    <span className={styles['item-current-bid']}>
                        <FormattedCurrencyContainer value={currentPrice} sourceCurrency={currency} noFraction />
                    </span>
                    <div className={styles['bid-count']}>
                        {bidActivityCount === 0 ? null : bidActivityCount === 1 ? (
                            <FormattedMessage id="oneBid" />
                        ) : (
                            <FormattedMessage id="bids_with_count" values={{ numberOfBids: bidActivityCount }} />
                        )}
                    </div>
                </span>
            ) : (
                <span className={styles['item-sold-bid-container']}>
                    <span className={styles['item-sold-bid']}>
                        {isSold ? (
                            <ItemPriceGatewayContainer containerClassName={styles['price-gateway-container']}>
                                <FormattedMessage
                                    id="sold_for"
                                    values={{
                                        amount: (
                                            <FormattedCurrencyContainer
                                                value={salePrice}
                                                sourceCurrency={currency}
                                                noFraction
                                            />
                                        ),
                                    }}
                                />
                            </ItemPriceGatewayContainer>
                        ) : isPassed || isUnsold ? (
                            <ItemPriceGatewayContainer containerClassName={styles['price-gateway-container']}>
                                {isCatalogOnly ? (
                                    <FormattedMessage id="lot_closed" />
                                ) : (
                                    <FormattedMessage id="lot_passed" />
                                )}
                            </ItemPriceGatewayContainer>
                        ) : null}
                    </span>
                </span>
            )}
        </div>
    );
};

export default React.memo<Props>(PriceRow);
